import { useMutation, UseMutationOptions } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { lender_filter_api } from '@axo/shared/data-access/api';
import { lender_filter, loan_application } from '@axo/shared/data-access/types';

export type CheckLoanApplicationVariables = {
  application: loan_application.LoanApplication;
  lenderIDs?: string[];
};

export type UseCheckLoanApplicationOptions = Omit<
  UseMutationOptions<
    lender_filter.CheckLoanApplicationResponse,
    Error,
    CheckLoanApplicationVariables
  >,
  'mutationFn'
>;

export function useCheckLoanApplication(
  options: UseCheckLoanApplicationOptions = {},
) {
  const api = useAPI();

  return useMutation<
    lender_filter.CheckLoanApplicationResponse,
    Error,
    CheckLoanApplicationVariables
  >(lender_filter_api.checkLoanApplication(api), options);
}
